/// <reference path="./config.d.ts" />
import type { Consultant } from "@landing/szakertok";
import type { AppConfigData } from "./utils/AppConfig";
import { AppConfig } from "./utils/AppConfig";

declare global {
	interface Window {
		dataLayer: any[];
		BM_DATAPAGE: Record<string, any>[];
		BM_CONSULTANT_DATAPAGE?: Consultant;
		APP_CONFIG: AppConfigData;
		tinymce: any;
		tinymceData: {
			calculators: { text: string; value: string }[];
			calculatorType: { text: string; value: string }[];
			leads: { text: string; value: string }[];
		};

		BM_RENDER_TYPE: "ssr" | "csr";
	}

	const BM_VERSION: string;
}

const { APP_CONFIG } = window;

export const Config = AppConfig.getInstance(APP_CONFIG);
